


























































import {Component, Vue} from "vue-property-decorator";
import Header from "@/components/public/Header.vue";
import Footer from "@/components/public/Footer.vue";
import ProjectItem from "@/components/ProjectItem.vue";
import DilemmaProjectItem from "@/components/DilemmaProjectItem.vue";
import AllocationProjectItem from "@/components/AllocationProjectItem.vue";
@Component({
  components:{
    'Header': Header,
    'Footer': Footer,
    'project-item': ProjectItem,
    'dilemma-project-item': DilemmaProjectItem,
    'allocation-project-item': AllocationProjectItem,
  }
})

export default class Project extends Vue{

  // 项目列表tabs
  private activeName:any=''

  private bankruptcyProjects:any=[];        //破产项目
  private dilemmaProjects:any=[];        //纾困项目
  private allocationProjects:any=[];        //配资项目
  private pageInfo:any={
    page: 1,
    size: 9,
    total: 0
  };
  private loading:boolean=false;

  created(){
    this.getProjects()
  }

  public changeActive() {
    this.pageInfo = {
      page: 1,
      size: 9,
      total: 0
    }
    this.getProjects()
  }

  public getProjects() {
    this.loading = true;
    let params = {
      ...this.pageInfo
    }
    if(this.activeName == 0){
      this.axios.get( this.$URL.BANKRUPTCY_LIST, { params }).then((res:any)=>{
        console.log( res.data, '1' )
        this.bankruptcyProjects = res.data.list
        this.pageInfo.total = res.data.total
        this.loading = false;
      })
    }else if(this.activeName == 1){
      this.axios.get( this.$URL.DILEMMA_LIST, { params }).then((res:any)=>{
        console.log( res.data, '2' )
        this.dilemmaProjects = res.data.list
        this.pageInfo.total = res.data.total
        this.loading = false;
      })
    }else{
      this.axios.get( this.$URL.ALLOCATION_LIST, { params }).then((res:any)=>{
        console.log( res.data, '3' )
        this.allocationProjects = res.data.list
        this.pageInfo.total = res.data.total
        this.loading = false;
      })
    }
  }

  public handleSizeChange(size:any) {
    this.pageInfo.size = size
  }

  public handleCurrentChange(page:any) {
    this.pageInfo.page = page
    const section = document.getElementById('project');
    if(section){
      section.scrollIntoView({ behavior: 'smooth' });
    }
    this.getProjects()
  }
}
